// Regras de data do Início: o que conta como "hoje" e quais próximos dias
// entram na lista de confirmação (na sexta: sábado, domingo e segunda;
// nos demais dias: o próximo dia útil).

const WEEKDAYS = ['domingo', 'segunda-feira', 'terça-feira', 'quarta-feira', 'quinta-feira', 'sexta-feira', 'sábado'];
const MONTHS = [
  'janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho',
  'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro',
];

export function toYMD(date) {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
}

/**
 * Converte para Date no fuso local. "2026-10-12" sozinho seria lido como
 * meia-noite UTC (o dia anterior, às 21h, no Brasil), então vira data local.
 */
export function toLocalDate(value) {
  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
    const [y, m, d] = value.split('-').map(Number);
    return new Date(y, m - 1, d);
  }
  return new Date(value);
}

export function isSameDay(a, b) {
  return toLocalDate(a).toDateString() === toLocalDate(b).toDateString();
}

export function isToday(date) {
  return isSameDay(date, new Date());
}

function getNextBusinessDay() {
  const next = new Date();
  next.setDate(next.getDate() + 1);
  while (next.getDay() === 0 || next.getDay() === 6) {
    next.setDate(next.getDate() + 1);
  }
  return next;
}

/** Datas futuras que entram na lista de confirmação. */
export function isInUpcomingRange(date) {
  const d = toLocalDate(date);
  const today = new Date();
  if (today.getDay() === 5) {
    const start = new Date(today);
    start.setDate(today.getDate() + 1);
    start.setHours(0, 0, 0, 0);
    const monday = new Date(today);
    monday.setDate(today.getDate() + 3);
    monday.setHours(23, 59, 59, 999);
    return d >= start && d <= monday;
  }
  return isSameDay(d, getNextBusinessDay());
}

/** "segunda-feira, 12 de outubro" */
export function formatLongDate(date = new Date()) {
  return `${WEEKDAYS[date.getDay()]}, ${date.getDate()} de ${MONTHS[date.getMonth()]}`;
}

/** "Hoje", "Amanhã" ou "Sábado, 17 de outubro" para o título de um grupo. */
export function formatDayLabel(date) {
  const d = toLocalDate(date);
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  if (isToday(d)) return 'Hoje';
  if (isSameDay(d, tomorrow)) return 'Amanhã';
  const weekday = WEEKDAYS[d.getDay()].replace('-feira', '');
  return `${weekday.charAt(0).toUpperCase()}${weekday.slice(1)}, ${d.getDate()} de ${MONTHS[d.getMonth()]}`;
}

/** "08:30" */
export function formatTime(date) {
  const d = new Date(date);
  return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
}

/** Tempo decorrido desde `date`: "há 20 min", "há 6 h", "há 2 dias". */
export function formatTimeAgo(date) {
  const minutes = Math.max(0, Math.round((Date.now() - toLocalDate(date).getTime()) / 60000));
  if (minutes < 60) return `há ${minutes} min`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `há ${hours} h`;
  const days = Math.floor(hours / 24);
  return `há ${days} ${days === 1 ? 'dia' : 'dias'}`;
}
